import * as React from "react";

import "./style.scss";
import {Box, Card, IconButton, Typography} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { getLocalDate } from "helpers/utils";


const SellerOrder = (props) => {

    const { order = {}, editOrderStatus } = props;
  const { _id, order_id, price, order_type, status, user, order_date } = order;

  return (
      <Card key={_id} className="m-2">
          <Box 
              alignContent="center" 
              width="100%" 
              display="flex" 
              p={2}
              onClick={editOrderStatus}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#fafafa'
                },
                position: 'relative'
              }}>
          <Box width="20%" order={1}>
                  <Typography align="left">
                      {order_id} ({order_type})
                  </Typography>
              </Box>
              <Box width="60%" order={2}>
                  <Typography align="left">
                      {user ? (<div className="delivery"><div><b>{user.name}</b></div><div>#{user.mobile}</div></div>) : <div className="delivery">User not available (please contact us)</div>}
                      {getLocalDate(order_date)}
                  </Typography>
              </Box>
              <Box width="20%" order={3} sx={{ position: 'relative' }}>
                  <Typography align="left" sx={{ color: status === 'pending' ? 'warning.main' : status === 'paid' ? 'success.main' : 'text.primary' }}>
                      {status}
                  </Typography>
                  <IconButton 
                      color="primary" 
                      size="small" 
                      onClick={(e) => {
                          e.stopPropagation();
                          editOrderStatus();
                      }}
                      sx={{
                          position: 'absolute',
                          right: 0,
                          top: '50%',
                          transform: 'translateY(-50%)',
                          backgroundColor: 'background.paper',
                          '&:hover': {
                              backgroundColor: 'action.hover'
                          }
                      }}
                  >
                      <EditIcon />
                  </IconButton>
              </Box>
          </Box>
      </Card>
  );
};

export default SellerOrder;
